import { render, staticRenderFns } from "./sepa.vue?vue&type=template&id=65d65d6d&scoped=true&"
import script from "./sepa.vue?vue&type=script&lang=js&"
export * from "./sepa.vue?vue&type=script&lang=js&"
import style0 from "./sepa.vue?vue&type=style&index=0&id=65d65d6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d65d6d",
  null
  
)

export default component.exports